<script setup>
import { computed, ref } from 'vue'
import { getIcon } from '@/tiptap/constants/icons'
import ActionButton from '../../ActionButton/src/index.vue'
import { actionButtonMenuProps } from './props'

// props schema (JS version)
const props = defineProps(actionButtonMenuProps)

const menu = ref(false)

const active = computed(() => {
  const find = props.items.find(k => (k.isActive && k.isActive()))
  if (find && !find.default) {
    return {
      ...find,
      icon: find.icon ? find.icon : props.icon,
    }
  }
  return {
    title: props.tooltip,
    icon: props.icon,
    isActive: () => false,
  }
})
</script>

<template>
  <ActionButton
    :editor="editor"
    :icon="active.icon"
    :tooltip="active.title"
    :disabled="disabled"
    :color="color"
    :is-active="active.isActive"
  >
    <VMenu v-model="menu" activator="parent">
      <VList density="compact" :max-height="maxHeight">
        <template v-for="(item, i) in items" :key="i">
          <VListItem :active="item.isActive()" :disabled="item.disabled" @click="item.action">
            <template #prepend>
              <VIcon v-if="item.icon" :icon="getIcon(item.icon)" />
            </template>

            <VListItemTitle :style="item.style">{{ item.title }}</VListItemTitle>
          </VListItem>

          <VDivider v-if="item.divider" />
        </template>
      </VList>
    </VMenu>
  </ActionButton>
</template>
